import { fetcher } from "helpers/fetcher";

import {
  TUpdateStaffMaternityChldrenLeaveReq,
  TUpdateStaffMaternityChldrenLeaveRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateEmployeeMaternityChldrenLeave = async (
  payload: TUpdateStaffMaternityChldrenLeaveReq
) => {
  return await fetcher<
    TUpdateStaffMaternityChldrenLeaveRes,
    TUpdateStaffMaternityChldrenLeaveReq["data"]
  >(ENDPOINT.USER.UPDATE_EMPLOYEE_MATERNITY_CHILDREN_LEAVE, {
    data: payload.data,
    headers: {
      [API_HEADER.USER_ID]: payload.idUser,
      [API_HEADER.VERSION]:
        ENDPOINT.USER.UPDATE_EMPLOYEE_MATERNITY_CHILDREN_LEAVE.version,
    },
  });
};

export const mutationUpdateEmployeeMaternityChldrenLeave = async (
  payload: TUpdateStaffMaternityChldrenLeaveReq
) => {
  return (await updateEmployeeMaternityChldrenLeave(payload)).data.message;
};

mutationUpdateEmployeeMaternityChldrenLeave._key = (
  payload: TUpdateStaffMaternityChldrenLeaveReq
) => [ENDPOINT.USER.UPDATE_EMPLOYEE_MATERNITY_CHILDREN_LEAVE.url, payload];
